import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TopBannerComponent } from '../top-banner/top-banner.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'pt-public-header',
  templateUrl: './public-header.component.html',
  styleUrls: ['./public-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TopBannerComponent, RouterLink],
})
export class PublicHeaderComponent {}
